import { useLocalization } from '@lib/localization';
import { MenuItem, TextField } from '@mui/material';
import { layoutFieldStyles } from '@pages/ReportBranding.styles';
import { brandableLayouts, isBrandableLayout, type BrandableLayout } from '@store/api/reportBrandingEndpoints';

interface Props {
  value: BrandableLayout;
  onChange: (layout: BrandableLayout) => void;
}

// The words each layout goes by where a report is downloaded.
const names: Record<BrandableLayout, string> = {
  compact: 'Report_Layout_Compact',
  executive: 'Report_Layout_Executive',
};

/**
 * Which layout the preview shows the brand on. The brand is one for every layout that takes
 * it, so this chooses a picture and edits nothing: it stands in the preview's toolbar, beside
 * the other things the picture is drawn from. It was a choice between two brands once, one
 * for each layout, and stood over the fields.
 */
const LayoutChoice: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useLocalization();

  return (
    <TextField
      select
      size="small"
      label={t('ReportBranding_Layout')}
      value={value}
      onChange={(event) => isBrandableLayout(event.target.value) && onChange(event.target.value)}
      sx={layoutFieldStyles}
    >
      {brandableLayouts.map((layout) => <MenuItem key={layout} value={layout}>{t(names[layout])}</MenuItem>)}
    </TextField>
  );
};

export default LayoutChoice;
